import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function GestionProducto() {
  const [productos, setProductos] = useState([]);
  const [productosFiltrados, setProductosFiltrados] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [ordenAsc, setOrdenAsc] = useState(true);
  const [columnaOrden, setColumnaOrden] = useState('idProducto');
  const [cargando, setCargando] = useState(true);
  
  // Paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const [registrosPorPagina, setRegistrosPorPagina] = useState(10);
  
  // Modal para crear/editar
  const [modalAbierto, setModalAbierto] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);

  // Catálogos para los select
  const [grupos, setGrupos] = useState([]);
  const [medidas, setMedidas] = useState([]);
  const [tiposProducto, setTiposProducto] = useState([]);

  // Estado para el selector de columnas
  const [selectorColumnasAbierto, setSelectorColumnasAbierto] = useState(false);
  const selectorRef = useRef(null);

  const API_URL = '/api/productos';
  const API_GRUPO_URL = '/api/grupo';
  const API_MEDIDA_URL = '/api/medida';
  const API_TIPO_URL = '/api/tipoprod';

  // Definición completa de todas las columnas disponibles
  const todasLasColumnas = [
    { key: 'idProducto', label: 'ID Producto', visible: true, fixed: true },
    { key: 'descripcion', label: 'Descripción', visible: true, fixed: true },
    { key: 'codbarra', label: 'Código Barras', visible: true },
    { key: 'idMedida', label: 'Medida', visible: true },
    { key: 'nomGrupo', label: 'Grupo', visible: true },
    { key: 'precio', label: 'Precio', visible: true },
    { key: 'existencia', label: 'Existencia', visible: true },
    { key: 'idTipoprod', label: 'Tipo Producto', visible: false },
    { key: 'ubicacion', label: 'Ubicación', visible: false },
    { key: 'gravada', label: 'Gravada', visible: false },
    { key: 'canNeta', label: 'Cantidad Neta', visible: false },
    { key: 'minimo', label: 'Stock Mínimo', visible: false },
    { key: 'maximo', label: 'Stock Máximo', visible: false },
    { key: 'canpedir', label: 'Cantidad a Pedir', visible: false },
    { key: 'costoprom', label: 'Costo Promedio', visible: false },
    { key: 'costoulcom', label: 'Costo Última Compra', visible: false },
    { key: 'fchentrada', label: 'Fecha Entrada', visible: false },
    { key: 'vencim', label: 'Vencimiento', visible: false },
    { key: 'fultvta', label: 'Fecha Última Venta', visible: false },
    { key: 'cuenta', label: 'Cuenta Contable', visible: false },
    { key: 'ventmin', label: 'Venta Mínima', visible: false },
    { key: 'ventmax', label: 'Venta Máxima', visible: false },
    { key: 'cupones', label: 'Cupones', visible: false },
    { key: 'fchultcom', label: 'Fecha Última Compra', visible: false },
    { key: 'idFormula', label: 'ID Fórmula', visible: false },
    { key: 'idMarca', label: 'ID Marca', visible: false },
    { key: 'pesoprom', label: 'Peso Promedio', visible: false },
    { key: 'porcvar', label: 'Porcentaje Variación', visible: false },
    { key: 'idFormaut', label: 'ID Fórmula Auto', visible: false },
    { key: 'obs', label: 'Observaciones', visible: false },
    { key: 'costomo', label: 'Costo MO', visible: false },
    { key: 'idLineaprod', label: 'ID Línea Producto', visible: false },
    { key: 'idFamiliaprod', label: 'ID Familia Producto', visible: false },
    { key: 'idRubroprod', label: 'ID Rubro Producto', visible: false },
    { key: 'idCatprod', label: 'ID Categoría Producto', visible: false },
    { key: 'rstock', label: 'Reposición Stock', visible: false },
    { key: 'cuentacosto', label: 'Cuenta Costo', visible: false },
    { key: 'cuentaactivo', label: 'Cuenta Activo', visible: false },
    { key: 'idPresent', label: 'ID Presentación', visible: false },
    { key: 'activo', label: 'Activo', visible: false },
    { key: 'obligalote', label: 'Obliga Lote', visible: false },
    { key: 'idDivision', label: 'ID División', visible: false },
    { key: 'promo', label: 'Promoción', visible: false },
    { key: 'idMeta', label: 'ID Meta', visible: false },
    { key: 'diasStock', label: 'Días Stock', visible: false },
    { key: 'orden', label: 'Orden', visible: false },
    { key: 'prodvigente', label: 'Producto Vigente', visible: false },
    { key: 'idGruporepos', label: 'ID Grupo Reposición', visible: false },
    { key: 'imagen1', label: 'Imagen 1', visible: false },
    { key: 'imagen2', label: 'Imagen 2', visible: false },
    { key: 'idEnvase', label: 'ID Envase', visible: false },
    { key: 'idGrupo', label: 'ID Grupo', visible: false },
    { key: 'acciones', label: 'Acciones', visible: true, fixed: true }
  ];

  const [columnasVisibles, setColumnasVisibles] = useState(() => {
    const guardadas = localStorage.getItem('columnasProductos');
    if (guardadas) {
      return JSON.parse(guardadas);
    }
    return todasLasColumnas;
  });

  useEffect(() => {
    cargarDatos();
    cargarCatalogos();
  }, []);

  useEffect(() => {
    filtrarProductos();
  }, [busqueda, productos]);

  useEffect(() => {
    setPaginaActual(1);
  }, [productosFiltrados, registrosPorPagina]);

  // Cerrar selector de columnas al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setSelectorColumnasAbierto(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Guardar configuración de columnas en localStorage
  useEffect(() => {
    localStorage.setItem('columnasProductos', JSON.stringify(columnasVisibles));
  }, [columnasVisibles]);

  const cargarDatos = async () => {
    try {
      setCargando(true);
      const response = await axios.get(API_URL);
      setProductos(response.data);
      setProductosFiltrados(response.data);
    } catch (error) {
      console.error('Error al cargar productos:', error);
      alert('Error al cargar los productos');
    } finally {
      setCargando(false);
    }
  };

  const cargarCatalogos = async () => {
    try {
      const [resGrupos, resMedidas, resTipos] = await Promise.all([
        axios.get(API_GRUPO_URL),
        axios.get(API_MEDIDA_URL),
        axios.get(API_TIPO_URL)
      ]);
      setGrupos(resGrupos.data);
      setMedidas(resMedidas.data);
      setTiposProducto(resTipos.data);
    } catch (error) {
      console.error('Error al cargar catálogos:', error);
    }
  };

  const filtrarProductos = () => {
    if (!busqueda) {
      setProductosFiltrados(productos);
      return;
    }

    const filtrados = productos.filter(item =>
      item.idProducto?.toString().includes(busqueda) ||
      item.descripcion?.toLowerCase().includes(busqueda.toLowerCase()) ||
      item.nomGrupo?.toLowerCase().includes(busqueda.toLowerCase()) ||
      item.idMedida?.toLowerCase().includes(busqueda.toLowerCase())
    );
    setProductosFiltrados(filtrados);
  };

  const ordenarPor = (columna) => {
    const esAsc = columnaOrden === columna ? !ordenAsc : true;
    setColumnaOrden(columna);
    setOrdenAsc(esAsc);

    const ordenados = [...productosFiltrados].sort((a, b) => {
      let valorA = a[columna];
      let valorB = b[columna];
      
      if (valorA === null || valorA === undefined) valorA = '';
      if (valorB === null || valorB === undefined) valorB = '';
      
      if (typeof valorA === 'string') {
        valorA = valorA.toLowerCase();
        valorB = valorB.toLowerCase();
      }
      
      if (esAsc) {
        return valorA > valorB ? 1 : -1;
      } else {
        return valorA < valorB ? 1 : -1;
      }
    });

    setProductosFiltrados(ordenados);
  };

  const toggleColumna = (key) => {
    setColumnasVisibles(prev => 
      prev.map(col => 
        col.key === key && !col.fixed 
          ? { ...col, visible: !col.visible }
          : col
      )
    );
  };

  const mostrarTodasColumnas = () => {
    setColumnasVisibles(prev => prev.map(col => ({ ...col, visible: true })));
  };

  const ocultarTodasColumnas = () => {
    setColumnasVisibles(prev => 
      prev.map(col => 
        col.fixed 
          ? col 
          : { ...col, visible: false }
      )
    );
  };

  const restaurarColumnasDefecto = () => {
    setColumnasVisibles(todasLasColumnas);
    localStorage.removeItem('columnasProductos');
  };

  const exportarExcel = () => {
    const columnasParaExportar = columnasVisibles.filter(col => col.visible && col.key !== 'acciones');
    
    const datosExportar = productosFiltrados.map(item => {
      const fila = {};
      columnasParaExportar.forEach(col => {
        fila[col.label] = formatearValor(item[col.key], col.key);
      });
      return fila;
    });

    const ws = XLSX.utils.json_to_sheet(datosExportar);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Productos');
    XLSX.writeFile(wb, 'productos.xlsx');
  };

  const formatearValor = (valor, key) => {
    if (valor === null || valor === undefined) return '';
    
    switch (key) {
      case 'precio':
      case 'costoprom':
      case 'costoulcom':
        return typeof valor === 'number' ? valor.toFixed(2) : valor;
      case 'existencia':
      case 'minimo':
      case 'maximo':
      case 'canNeta':
      case 'canpedir':
        return typeof valor === 'number' ? valor.toFixed(3) : valor;
      case 'gravada':
        // 0 = Exenta, 5 y 10 = % de IVA gravado (Paraguay)
        if (valor === 0 || valor === '0') return 'Exenta';
        if (valor === 5 || valor === '5') return '5%';
        if (valor === 10 || valor === '10') return '10%';
        // Compatibilidad con valores viejos (1=Si, 0=No)
        return valor === 1 ? 'Gravada' : (valor || '-');
      case 'activo':
        return valor === 1 ? 'Activo' : 'Inactivo';
      case 'fchentrada':
      case 'vencim':
      case 'fultvta':
      case 'fchultcom':
        return valor ? new Date(valor).toLocaleDateString() : '';
      default:
        return valor;
    }
  };

  const abrirModalNuevo = () => {
    setProductoSeleccionado(null);
    setModoEdicion(false);
    setModalAbierto(true);
  };

  const abrirModalEditar = (producto) => {
    setProductoSeleccionado(producto);
    setModoEdicion(true);
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setProductoSeleccionado(null);
    cargarDatos();
  };

  const eliminar = async (id) => {
    if (window.confirm('¿Está seguro de eliminar este producto?')) {
      try {
        await axios.delete(`${API_URL}/${id}`);
        alert('Producto eliminado exitosamente');
        cargarDatos();
      } catch (error) {
        console.error('Error al eliminar:', error);
        alert('Error al eliminar el producto');
      }
    }
  };

  const getNombreGrupo = (idGrupo) => {
    const grupo = grupos.find(g => g.idGrupo === idGrupo);
    return grupo ? grupo.nomGrupo : '-';
  };

  const getNombreMedida = (idMedida) => {
    const medida = medidas.find(m => m.idMedida === idMedida);
    return medida ? medida.nomMedida : idMedida || '-';
  };

  // Cálculos de paginación
  const indiceUltimo = paginaActual * registrosPorPagina;
  const indicePrimero = indiceUltimo - registrosPorPagina;
  const productosActuales = productosFiltrados.slice(indicePrimero, indiceUltimo);
  const totalPaginas = Math.ceil(productosFiltrados.length / registrosPorPagina);

  const irAPagina = (numeroPagina) => setPaginaActual(numeroPagina);
  const paginaAnterior = () => paginaActual > 1 && setPaginaActual(paginaActual - 1);
  const paginaSiguiente = () => paginaActual < totalPaginas && setPaginaActual(paginaActual + 1);
  const primeraPagina = () => setPaginaActual(1);
  const ultimaPagina = () => setPaginaActual(totalPaginas);

  const generarNumerosPagina = () => {
    const numeros = [];
    const maxNumeros = 5;
    
    let inicio = Math.max(1, paginaActual - Math.floor(maxNumeros / 2));
    let fin = Math.min(totalPaginas, inicio + maxNumeros - 1);
    
    if (fin - inicio < maxNumeros - 1) {
      inicio = Math.max(1, fin - maxNumeros + 1);
    }
    
    for (let i = inicio; i <= fin; i++) {
      numeros.push(i);
    }
    
    return numeros;
  };

  if (cargando) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando productos...</p>
      </div>
    );
  }

  return (
    <div className="gestion-producto-container">
      <div className="header-seccion">
        <h2>Gestión de Productos</h2>
        <div className="acciones-header">
          <input
            type="text"
            placeholder="Buscar productos..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className="input-busqueda"
          />
          <div className="selector-columnas-wrapper" ref={selectorRef}>
            <button 
              onClick={() => setSelectorColumnasAbierto(!selectorColumnasAbierto)}
              className="btn btn-columnas"
              title="Configurar columnas"
            >
              ⚙️ Columnas
            </button>
            
            {selectorColumnasAbierto && (
              <div className="selector-columnas-dropdown">
                <div className="selector-columnas-header">
                  <h4>Configurar Columnas</h4>
                  <button 
                    onClick={() => setSelectorColumnasAbierto(false)}
                    className="btn-cerrar-selector"
                  >
                    ✖
                  </button>
                </div>
                
                <div className="selector-columnas-acciones">
                  <button onClick={mostrarTodasColumnas} className="btn-selector-mini">
                    ✓ Todas
                  </button>
                  <button onClick={ocultarTodasColumnas} className="btn-selector-mini">
                    ✗ Ninguna
                  </button>
                  <button onClick={restaurarColumnasDefecto} className="btn-selector-mini">
                    ↺ Restaurar
                  </button>
                </div>

                <div className="selector-columnas-lista">
                  {columnasVisibles.map(columna => (
                    <label 
                      key={columna.key} 
                      className={`selector-columna-item ${columna.fixed ? 'fija' : ''}`}
                    >
                      <input
                        type="checkbox"
                        checked={columna.visible}
                        onChange={() => toggleColumna(columna.key)}
                        disabled={columna.fixed}
                      />
                      <span>{columna.label}</span>
                      {columna.fixed && <span className="badge-fija">Fija</span>}
                    </label>
                  ))}
                </div>

                <div className="selector-columnas-footer">
                  <small>
                    {columnasVisibles.filter(c => c.visible).length} de {columnasVisibles.length} columnas visibles
                  </small>
                </div>
              </div>
            )}
          </div>
          <button onClick={abrirModalNuevo} className="btn btn-nuevo">
            + Nuevo Producto
          </button>
          <button onClick={exportarExcel} className="btn btn-exportar">
            📊 Exportar Excel
          </button>
        </div>
      </div>

      <div className="tabla-container">
        <table className="tabla-datos">
          <thead>
            <tr>
              {columnasVisibles.filter(col => col.visible).map(columna => (
                <th 
                  key={columna.key}
                  className={columna.key !== 'acciones' ? 'th-ordenable' : ''}
                  onClick={() => columna.key !== 'acciones' && ordenarPor(columna.key)}
                >
                  {columna.label}
                  {columnaOrden === columna.key && (
                    <span>{ordenAsc ? ' ▲' : ' ▼'}</span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {productosActuales.length === 0 ? (
              <tr>
                <td colSpan={columnasVisibles.filter(col => col.visible).length} className="sin-datos">
                  No se encontraron productos
                </td>
              </tr>
            ) : (
              productosActuales.map((producto) => (
                <tr key={producto.idProducto}>
                  {columnasVisibles.filter(col => col.visible).map(columna => {
                    if (columna.key === 'acciones') {
                      return (
                        <td key={columna.key}>
                          <button
                            onClick={() => abrirModalEditar(producto)}
                            className="btn-accion"
                            title="Editar"
                          >
                            ✏️
                          </button>
                          <button
                            onClick={() => eliminar(producto.idProducto)}
                            className="btn-accion"
                            title="Eliminar"
                          >
                            🗑️
                          </button>
                        </td>
                      );
                    }
                    
                    return (
                      <td 
                        key={columna.key}
                        className={columna.key === 'descripcion' ? 'td-descripcion' : ''}
                      >
                        {formatearValor(producto[columna.key], columna.key)}
                      </td>
                    );
                  })}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      <div className="paginacion-container">
        <div className="paginacion-info">
          <span>
            Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, productosFiltrados.length)} de {productosFiltrados.length} registros
          </span>
          <select
            value={registrosPorPagina}
            onChange={(e) => setRegistrosPorPagina(Number(e.target.value))}
            className="select-registros"
          >
            <option value={5}>5 por página</option>
            <option value={10}>10 por página</option>
            <option value={25}>25 por página</option>
            <option value={50}>50 por página</option>
            <option value={100}>100 por página</option>
          </select>
        </div>

        <div className="paginacion-controles">
          <button 
            onClick={primeraPagina} 
            disabled={paginaActual === 1}
            className="btn-paginacion"
            title="Primera página"
          >
            ⏮️
          </button>
          <button 
            onClick={paginaAnterior} 
            disabled={paginaActual === 1}
            className="btn-paginacion"
          >
            ◀️
          </button>
          
          {generarNumerosPagina().map(numero => (
            <button
              key={numero}
              onClick={() => irAPagina(numero)}
              className={`btn-numero-pagina ${paginaActual === numero ? 'activo' : ''}`}
            >
              {numero}
            </button>
          ))}
          
          <button 
            onClick={paginaSiguiente} 
            disabled={paginaActual === totalPaginas}
            className="btn-paginacion"
          >
            ▶️
          </button>
          <button 
            onClick={ultimaPagina} 
            disabled={paginaActual === totalPaginas}
            className="btn-paginacion"
            title="Última página"
          >
            ⏭️
          </button>
        </div>
      </div>

      {/* Modal para crear/editar */}
      {modalAbierto && (
        <FormularioProducto
          productoInicial={productoSeleccionado}
          modoEdicion={modoEdicion}
          onCancelar={cerrarModal}
          onGuardado={cerrarModal}
          grupos={grupos}
          medidas={medidas}
          tiposProducto={tiposProducto}
        />
      )}
    </div>
  );
}

// Componente FormularioProducto (mantener el mismo del archivo original)
function FormularioProducto({ productoInicial, modoEdicion, onCancelar, onGuardado, grupos, medidas, tiposProducto }) {
  const [mensaje, setMensaje] = useState({ texto: '', tipo: '' });
  const [cuentas, setCuentas] = useState([]);
  
  // Estados para los dropdowns de cuentas
  const [dropdownCuentaAbierto, setDropdownCuentaAbierto] = useState(false);
  const [dropdownCuentaCostoAbierto, setDropdownCuentaCostoAbierto] = useState(false);
  const [dropdownCuentaActivoAbierto, setDropdownCuentaActivoAbierto] = useState(false);
  
  const [busquedaCuenta, setBusquedaCuenta] = useState('');
  const [busquedaCuentaCosto, setBusquedaCuentaCosto] = useState('');
  const [busquedaCuentaActivo, setBusquedaCuentaActivo] = useState('');

  const dropdownCuentaRef = useRef(null);
  const dropdownCuentaCostoRef = useRef(null);
  const dropdownCuentaActivoRef = useRef(null);

  const API_CUENTA_URL = '/api/cuentas';

  const [formulario, setFormulario] = useState({
    idProducto: productoInicial?.idProducto || '',
    codbarra: productoInicial?.codbarra || '',
    idGrupo: productoInicial?.idGrupo || '',
    descripcion: productoInicial?.descripcion || '',
    idMedida: productoInicial?.idMedida || '',
    idEnvase: productoInicial?.idEnvase || '',
    idTipoprod: productoInicial?.idTipoprod || '',
    ubicacion: productoInicial?.ubicacion || '',
    gravada: productoInicial?.gravada !== undefined ? productoInicial.gravada : 10,
    canNeta: productoInicial?.canNeta || 0,
    existencia: productoInicial?.existencia || 0,
    minimo: productoInicial?.minimo || 0,
    maximo: productoInicial?.maximo || 0,
    canpedir: productoInicial?.canpedir || 0,
    costoprom: productoInicial?.costoprom || 0,
    costoulcom: productoInicial?.costoulcom || 0,
    precio: productoInicial?.precio || 0,
    fchentrada: productoInicial?.fchentrada || '',
    vencim: productoInicial?.vencim || '',
    fultvta: productoInicial?.fultvta || '',
    cuenta: productoInicial?.cuenta || '',
    ventmin: productoInicial?.ventmin || 0,
    ventmax: productoInicial?.ventmax || -1,
    cupones: productoInicial?.cupones || null,
    fchultcom: productoInicial?.fchultcom || '',
    idFormula: productoInicial?.idFormula || null,
    idMarca: productoInicial?.idMarca || 0,
    pesoprom: productoInicial?.pesoprom || null,
    porcvar: productoInicial?.porcvar || null,
    idFormaut: productoInicial?.idFormaut || 0,
    obs: productoInicial?.obs || '',
    costomo: productoInicial?.costomo || 0,
    idLineaprod: productoInicial?.idLineaprod || 0,
    idFamiliaprod: productoInicial?.idFamiliaprod || ' ',
    idRubroprod: productoInicial?.idRubroprod || ' ',
    idCatprod: productoInicial?.idCatprod || 0,
    rstock: productoInicial?.rstock || 'S',
    cuentacosto: productoInicial?.cuentacosto || '',
    cuentaactivo: productoInicial?.cuentaactivo || '',
    idPresent: productoInicial?.idPresent || 'UN',
    activo: productoInicial?.activo !== undefined ? productoInicial.activo : 1,
    obligalote: productoInicial?.obligalote || 'NO',
    idDivision: productoInicial?.idDivision || 'SP',
    promo: productoInicial?.promo || 0,
    idMeta: productoInicial?.idMeta || '0',
    diasStock: productoInicial?.diasStock || 90,
    orden: productoInicial?.orden || 1,
    prodvigente: productoInicial?.prodvigente || 'S',
    idGruporepos: productoInicial?.idGruporepos || 0,
    imagen1: productoInicial?.imagen1 || '',
    imagen2: productoInicial?.imagen2 || ''
  });

  useEffect(() => {
    cargarCuentas();
    // Solo precargar proximo id_producto si es alta nueva (sin productoInicial)
    if (!productoInicial?.idProducto) {
      cargarProximoId();
    }
  }, []);

  const cargarProximoId = async () => {
    try {
      const resp = await axios.get('/api/productos/proximo-id');
      setFormulario(prev => ({ ...prev, idProducto: resp.data }));
    } catch (e) {
      console.error('Error al obtener proximo id_producto:', e);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownCuentaRef.current && !dropdownCuentaRef.current.contains(event.target)) {
        setDropdownCuentaAbierto(false);
      }
      if (dropdownCuentaCostoRef.current && !dropdownCuentaCostoRef.current.contains(event.target)) {
        setDropdownCuentaCostoAbierto(false);
      }
      if (dropdownCuentaActivoRef.current && !dropdownCuentaActivoRef.current.contains(event.target)) {
        setDropdownCuentaActivoAbierto(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const cargarCuentas = async () => {
    try {
      // Usar el endpoint de cuentas imputables para obtener solo cuentas con imputable = 'S'
      const response = await axios.get(`${API_CUENTA_URL}/imputables`);
      setCuentas(response.data);
    } catch (error) {
      console.error('Error al cargar cuentas:', error);
    }
  };

  const filtrarCuentas = (busqueda) => {
    if (!busqueda) return cuentas;
    const busquedaLower = busqueda.toLowerCase();
    return cuentas.filter(cuenta =>
      cuenta.cuenta?.toLowerCase().includes(busquedaLower) ||
      cuenta.descripcion?.toLowerCase().includes(busquedaLower)
    );
  };

  const seleccionarCuenta = (cuenta, campo) => {
    setFormulario(prev => ({ ...prev, [campo]: cuenta.cuenta }));
    if (campo === 'cuenta') {
      setDropdownCuentaAbierto(false);
      setBusquedaCuenta('');
    } else if (campo === 'cuentacosto') {
      setDropdownCuentaCostoAbierto(false);
      setBusquedaCuentaCosto('');
    } else if (campo === 'cuentaactivo') {
      setDropdownCuentaActivoAbierto(false);
      setBusquedaCuentaActivo('');
    }
  };

  const limpiarCuenta = (campo) => {
    setFormulario(prev => ({ ...prev, [campo]: '' }));
  };

  const obtenerDescripcionCuenta = (numeroCuenta) => {
    const cuenta = cuentas.find(c => c.cuenta === numeroCuenta);
    return cuenta ? cuenta.descripcion : '';
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormulario(prev => ({
      ...prev,
      [name]: type === 'number' ? (value === '' ? '' : Number(value)) : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formulario.idProducto || !formulario.descripcion || !formulario.idGrupo) {
      setMensaje({ texto: 'Los campos ID Producto, Descripción y Grupo son obligatorios', tipo: 'error' });
      return;
    }

    try {
      const productoDTO = { ...formulario };

      if (modoEdicion) {
        await axios.put(`/api/productos/${formulario.idProducto}`, productoDTO);
        setMensaje({ texto: 'Producto actualizado exitosamente', tipo: 'success' });
      } else {
        await axios.post('/api/productos', productoDTO);
        setMensaje({ texto: 'Producto creado exitosamente', tipo: 'success' });
      }

      setTimeout(() => {
        onGuardado();
      }, 1500);

    } catch (error) {
      console.error('Error al guardar:', error);
      setMensaje({ 
        texto: error.response?.data?.message || 'Error al guardar el producto', 
        tipo: 'error' 
      });
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-contenido-grande">
        <div className="modal-header">
          <h3>{modoEdicion ? 'Editar Producto' : 'Nuevo Producto'}</h3>
          <button onClick={onCancelar} className="btn-cerrar">×</button>
        </div>
        <div className="modal-body">
          <FormularioProductoContent
            formulario={formulario}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            mensaje={mensaje}
            grupos={grupos}
            medidas={medidas}
            tiposProducto={tiposProducto}
            modoEdicion={modoEdicion}
            onCancelar={onCancelar}
            dropdownCuentaRef={dropdownCuentaRef}
            dropdownCuentaCostoRef={dropdownCuentaCostoRef}
            dropdownCuentaActivoRef={dropdownCuentaActivoRef}
            dropdownCuentaAbierto={dropdownCuentaAbierto}
            setDropdownCuentaAbierto={setDropdownCuentaAbierto}
            dropdownCuentaCostoAbierto={dropdownCuentaCostoAbierto}
            setDropdownCuentaCostoAbierto={setDropdownCuentaCostoAbierto}
            dropdownCuentaActivoAbierto={dropdownCuentaActivoAbierto}
            setDropdownCuentaActivoAbierto={setDropdownCuentaActivoAbierto}
            busquedaCuenta={busquedaCuenta}
            setBusquedaCuenta={setBusquedaCuenta}
            busquedaCuentaCosto={busquedaCuentaCosto}
            setBusquedaCuentaCosto={setBusquedaCuentaCosto}
            busquedaCuentaActivo={busquedaCuentaActivo}
            setBusquedaCuentaActivo={setBusquedaCuentaActivo}
            filtrarCuentas={filtrarCuentas}
            seleccionarCuenta={seleccionarCuenta}
            limpiarCuenta={limpiarCuenta}
            obtenerDescripcionCuenta={obtenerDescripcionCuenta}
          />
        </div>
      </div>
    </div>
  );
}

function FormularioProductoContent({
  formulario,
  handleChange,
  handleSubmit,
  mensaje,
  grupos,
  medidas,
  tiposProducto,
  modoEdicion,
  onCancelar,
  dropdownCuentaRef,
  dropdownCuentaCostoRef,
  dropdownCuentaActivoRef,
  dropdownCuentaAbierto,
  setDropdownCuentaAbierto,
  dropdownCuentaCostoAbierto,
  setDropdownCuentaCostoAbierto,
  dropdownCuentaActivoAbierto,
  setDropdownCuentaActivoAbierto,
  busquedaCuenta,
  setBusquedaCuenta,
  busquedaCuentaCosto,
  setBusquedaCuentaCosto,
  busquedaCuentaActivo,
  setBusquedaCuentaActivo,
  filtrarCuentas,
  seleccionarCuenta,
  limpiarCuenta,
  obtenerDescripcionCuenta
}) {
  return (
    <form onSubmit={handleSubmit} className="formulario-producto">
      {mensaje.texto && (
        <div className={`mensaje ${mensaje.tipo}`}>
          {mensaje.texto}
        </div>
      )}

      <div className="form-grid">
        {/* Sección Información Básica */}
        <div className="form-section">
          <h3>Información Básica</h3>
          
          <div className="form-group">
            <label>ID Producto <span className="required">*</span></label>
            <input
              type="number"
              name="idProducto"
              value={formulario.idProducto}
              readOnly
              tabIndex={-1}
              className="form-input"
              placeholder={modoEdicion ? '' : 'Cargando...'}
              style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
              title={modoEdicion ? 'ID no editable' : 'Auto-generado (MAX+1)'}
            />
          </div>

          <div className="form-group">
            <label>Código de Barras</label>
            <input
              type="text"
              name="codbarra"
              value={formulario.codbarra}
              onChange={handleChange}
              maxLength="13"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label>Descripción <span className="required">*</span></label>
            <textarea
              name="descripcion"
              value={formulario.descripcion}
              onChange={handleChange}
              required
              maxLength="240"
              className="form-input"
              rows="3"
            />
          </div>

          
        
        </div>
        {/* Sección De Clasificacion */}
        <div className="form-section">
          <div className="form-group">
            <label>Grupo <span className="required">*</span></label>
            <select name="idGrupo" value={formulario.idGrupo} onChange={handleChange} required className="form-input">
              <option value="">Seleccione un grupo</option>
              {grupos.map(grupo => (
                <option key={grupo.idGrupo} value={grupo.idGrupo}>{grupo.nomGrupo}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Medida</label>
            <select name="idMedida" value={formulario.idMedida} onChange={handleChange} className="form-input">
              <option value="">Seleccione</option>
              {medidas.map(medida => (
                <option key={medida.idMedida} value={medida.idMedida}>{medida.nomMedida}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Tipo Producto</label>
            <select name="idTipo" value={formulario.idTipo} onChange={handleChange} className="form-input">
              <option value="">Seleccione</option>
              {tiposProducto.map(tipo => (
                <option key={tipo.idTipo} value={tipo.idTipo}>{tipo.nomTipo}</option>
              ))}
            </select>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Gravada (IVA %)</label>
              <select name="gravada" value={formulario.gravada} onChange={handleChange} className="form-input">
                <option value="0">Exenta (0%)</option>
                <option value="5">Gravada 5%</option>
                <option value="10">Gravada 10%</option>
              </select>
            </div>
            <div className="form-group">
              <label>Estado</label>
              <select name="activo" value={formulario.activo} onChange={handleChange} className="form-input">
                <option value="1">Activo</option>
                <option value="0">Inactivo</option>
              </select>
            </div>
          </div>
        </div>
        {/* Sección Precios y Stock */}
        <div className="form-section">
          <h3>Precios y Stock</h3>
          
          <div className="form-row">
            <div className="form-group">
              <label>Precio</label>
              <input type="number" name="precio" value={formulario.precio} onChange={handleChange} step="0.01" className="form-input" />
            </div>
            <div className="form-group">
              <label>Costo Promedio</label>
              <input type="number" name="costoprom" value={formulario.costoprom} onChange={handleChange} step="0.01" className="form-input" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Existencia</label>
              <input type="number" name="existencia" value={formulario.existencia} onChange={handleChange} step="0.001" className="form-input" />
            </div>
            <div className="form-group">
              <label>Mínimo</label>
              <input type="number" name="minimo" value={formulario.minimo} onChange={handleChange} step="0.001" className="form-input" />
            </div>
            <div className="form-group">
              <label>Máximo</label>
              <input type="number" name="maximo" value={formulario.maximo} onChange={handleChange} step="0.001" className="form-input" />
            </div>
          </div>
        </div>

        {/* Sección Contabilidad */}
        <div className="form-section">
          <h3>Contabilidad</h3>
          
          <div className="form-group">
            <label>Cuenta Contable</label>
            <div className="cuenta-selector" ref={dropdownCuentaRef}>
              <input
                type="text"
                value={formulario.cuenta || busquedaCuenta}
                onChange={(e) => {
                  setBusquedaCuenta(e.target.value);
                  setDropdownCuentaAbierto(true);
                }}
                onFocus={() => setDropdownCuentaAbierto(true)}
                placeholder="Buscar cuenta..."
                className="form-input"
              />
              {formulario.cuenta && (
                <div className="cuenta-seleccionada">
                  <span className="cuenta-numero">{formulario.cuenta}</span>
                  <span className="cuenta-descripcion">({obtenerDescripcionCuenta(formulario.cuenta)})</span>
                  <button type="button" onClick={() => limpiarCuenta('cuenta')} className="btn-clear-cuenta">✖</button>
                </div>
              )}
              {dropdownCuentaAbierto && (
                <div className="cuenta-dropdown">
                  {filtrarCuentas(busquedaCuenta).length === 0 ? (
                    <div className="cuenta-item-vacio">No se encontraron cuentas</div>
                  ) : (
                    filtrarCuentas(busquedaCuenta).slice(0, 50).map(cuenta => (
                      <div key={cuenta.cuenta} onClick={() => seleccionarCuenta(cuenta, 'cuenta')} className="cuenta-item">
                        <span className="cuenta-descripcion">{cuenta.descripcion}</span>
                        <span className="cuenta-numero">({cuenta.cuenta})</span>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="form-group">
            <label>Cuenta Costo</label>
            <div className="cuenta-selector" ref={dropdownCuentaCostoRef}>
              <input
                type="text"
                value={formulario.cuentacosto || busquedaCuentaCosto}
                onChange={(e) => {
                  setBusquedaCuentaCosto(e.target.value);
                  setDropdownCuentaCostoAbierto(true);
                }}
                onFocus={() => setDropdownCuentaCostoAbierto(true)}
                placeholder="Buscar cuenta costo..."
                className="form-input"
              />
              {formulario.cuentacosto && (
                <div className="cuenta-seleccionada">
                  <span className="cuenta-numero">{formulario.cuentacosto}</span>
                  <span className="cuenta-descripcion">({obtenerDescripcionCuenta(formulario.cuentacosto)})</span>
                  <button type="button" onClick={() => limpiarCuenta('cuentacosto')} className="btn-clear-cuenta">✖</button>
                </div>
              )}
              {dropdownCuentaCostoAbierto && (
                <div className="cuenta-dropdown">
                  {filtrarCuentas(busquedaCuentaCosto).length === 0 ? (
                    <div className="cuenta-item-vacio">No se encontraron cuentas</div>
                  ) : (
                    filtrarCuentas(busquedaCuentaCosto).slice(0, 50).map(cuenta => (
                      <div key={cuenta.cuenta} onClick={() => seleccionarCuenta(cuenta, 'cuentacosto')} className="cuenta-item">
                        <span className="cuenta-descripcion">{cuenta.descripcion}</span>
                        <span className="cuenta-numero">({cuenta.cuenta})</span>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="form-group">
            <label>Cuenta Activo</label>
            <div className="cuenta-selector" ref={dropdownCuentaActivoRef}>
              <input
                type="text"
                value={formulario.cuentaactivo || busquedaCuentaActivo}
                onChange={(e) => {
                  setBusquedaCuentaActivo(e.target.value);
                  setDropdownCuentaActivoAbierto(true);
                }}
                onFocus={() => setDropdownCuentaActivoAbierto(true)}
                placeholder="Buscar cuenta activo..."
                className="form-input"
              />
              {formulario.cuentaactivo && (
                <div className="cuenta-seleccionada">
                  <span className="cuenta-numero">{formulario.cuentaactivo}</span>
                  <span className="cuenta-descripcion">({obtenerDescripcionCuenta(formulario.cuentaactivo)})</span>
                  <button type="button" onClick={() => limpiarCuenta('cuentaactivo')} className="btn-clear-cuenta">✖</button>
                </div>
              )}
              {dropdownCuentaActivoAbierto && (
                <div className="cuenta-dropdown">
                  {filtrarCuentas(busquedaCuentaActivo).length === 0 ? (
                    <div className="cuenta-item-vacio">No se encontraron cuentas</div>
                  ) : (
                    filtrarCuentas(busquedaCuentaActivo).slice(0, 50).map(cuenta => (
                      <div key={cuenta.cuenta} onClick={() => seleccionarCuenta(cuenta, 'cuentaactivo')} className="cuenta-item">
                        <span className="cuenta-descripcion">{cuenta.descripcion}</span>
                        <span className="cuenta-numero">({cuenta.cuenta})</span>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="form-group">
            <label>Observaciones</label>
            <textarea name="obs" value={formulario.obs} onChange={handleChange} maxLength="250" className="form-input" rows="3" />
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button type="button" onClick={onCancelar} className="btn-secondary">Cancelar</button>
        <button type="submit" className="btn-primary">{modoEdicion ? 'Actualizar' : 'Guardar'}</button>
      </div>
    </form>
  );
}

export default GestionProducto;
